<script setup>
import {useBaseStore} from "~/stores/base";
import Drawer from "~/components/Drawer.vue";

/** emits **/
const emits = defineEmits(["change"])

/** props **/
const props = defineProps({
  product: {
    default: {},
    required: true
  },
  currentColorIndex: {
    default: 0,
    required: true
  }
})

const isShowExplain = ref(false)

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const currentColor = computed(() => props.product.newVariantOptions?.colorList[props.currentColorIndex].color)
const currentSizeRange = computed(() => props.product.optionConfig?.find(config => config.name === currentColor.value).sizeRange)

</script>

<template>
  <div class="module-product-size-range-mobile" v-if="isMobile">
    <div class="text">
      Size Range:&nbsp;<span style="font-weight: 650">{{ currentSizeRange }}</span> <img src="@/assets/img/icon-question-mark.svg" alt="icon" @click="isShowExplain = !isShowExplain">
    </div>
    <Drawer
      :position="'bottom'"
      :border-radius="'20px 20px 0 0'"
      :open="isShowExplain"
      :btnCloseVisible="true"
      @close="isShowExplain = false"
    >
      <div class="explain">
        {{ product.sizeRangeTips }}
      </div>
    </Drawer>
  </div>
  <div class="module-product-size-range-desktop" v-else>
    <div class="text">
      Size Range:&nbsp;<span style="font-weight: 650">{{ currentSizeRange }}</span> <img src="@/assets/img/icon-question-mark.svg" alt="icon" @click="isShowExplain = !isShowExplain">
    </div>

    <transition name="fade" mode="out-in">
      <div class="explain" v-show="isShowExplain">
        {{ product.sizeRangeTips }}
        <img src="@/assets/img/icon-close-black.svg" alt="close" @click="isShowExplain = !isShowExplain">
      </div>
    </transition>
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/config";

.module-product-size-range-mobile {
  margin-top: 12px;
  padding: 0 16px;

  .text {
    color: $color-gray-800;
    font-family: "TWK Lausanne";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px; /* 142.857% */

    display: flex;
    align-items: center;

    img {
      cursor: pointer;
      margin-left: 8px;
    }
  }

  .explain {
    color: $color-gray-800;
    font-family: "TWK Lausanne";
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 16px; /* 133.333% */

    padding: 60px 16px;
  }

}

.module-product-size-range-desktop {
  margin-top: 12px;
  position: relative;

  .text {
    color: $color-gray-800;
    font-family: "TWK Lausanne";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px; /* 142.857% */

    display: flex;
    align-items: center;

    img {
      cursor: pointer;
      margin-left: 8px;
    }
  }

  .explain {
    color: $color-gray-800;
    font-family: "TWK Lausanne";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */

    border: 0.5px solid $color-BNTO-beige-dark;
    background: #FFF;
    box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.08);

    position: absolute;
    left: 120px;
    top: 25px;

    display: flex;
    width: 294px;
    padding: 10px;
    align-items: flex-start;

    img {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
}

</style>
